var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinePlus = function SvgIconLinePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 2v5.333H14v1.334H8.667V14H7.333V8.667H2V7.333h5.333V2z"
  })));
};
export { SvgIconLinePlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjY2NjY3IDJWNy4zMzMzM0gxNFY4LjY2NjY3SDguNjY2NjdWMTRINy4zMzMzM1Y4LjY2NjY3SDJWNy4zMzMzM0g3LjMzMzMzVjJIOC42NjY2N1oiIC8+Cjwvc3ZnPgo=";